export const isEmptyObject = (obj: Record<string, unknown>) => {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
};
